/* Native option facets count sold-out variants. Read live variant stock from
   every matching collection page before presenting condition counts/results. */
(function () {
  'use strict';
  var conditionParam = 'filter.v.option.condition';
  var pageSize = 24;

  function counts(products) {
    var result = new Map();
    products.forEach(function (product) {
      new Set(product.variants.map(function (variant) { return variant.condition; }))
        .forEach(function (condition) {
          if (condition) result.set(condition, (result.get(condition) || 0) + 1);
        });
    });
    return result;
  }

  function matches(products, selected) {
    return products.map(function (product) {
      var variants = product.variants.filter(function (variant) {
        return !selected.length || selected.includes(variant.condition);
      });
      return Object.assign({}, product, { variants: variants });
    }).filter(function (product) { return product.variants.length > 0; });
  }

  function ordered(products, sortBy) {
    var result = products.slice();
    if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
      function minimum(product) {
        var prices = product.variants.map(function (variant) { return variant.price; })
          .filter(function (price) { return typeof price === 'number' && Number.isFinite(price); });
        return prices.length ? Math.min.apply(null, prices) : null;
      }
      result.sort(function (a, b) {
        var left = minimum(a), right = minimum(b);
        if (left === null) return right === null ? 0 : 1;
        if (right === null) return -1;
        return sortBy === 'price-ascending' ? left - right : right - left;
      });
    } else if (sortBy === 'manual') {
      result.sort(function (a, b) { return Number(!!b.pushed) - Number(!!a.pushed); });
    }
    return result;
  }

  function gradeSummary(variants) {
    var totals = new Map();
    variants.forEach(function (variant) {
      var label = variant.condition === 'A1' ? 'Grade A1' : variant.condition;
      if (label) totals.set(label, (totals.get(label) || 0) + variant.quantity);
    });
    return Array.from(totals, function (entry) { return entry[1] + ' ' + entry[0]; }).join(' \u00b7 ');
  }

  async function loadProducts(url, fetchPage) {
    var products = new Map();
    var pages = 1;
    for (var page = 1; page <= pages; page++) {
      url.searchParams.set('page', String(page));
      var response = await fetchPage(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Stock lookup failed');
      var data = await response.json();
      if (data.error || !Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 0) {
        throw new Error('Stock lookup unavailable');
      }
      pages = data.pages;
      data.products.forEach(function (product) { products.set(product.id, product); });
    }
    return Array.from(products.values());
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { counts: counts, matches: matches, loadProducts: loadProducts, ordered: ordered, gradeSummary: gradeSummary };
    return;
  }

  window.HciCollectionStock = { counts: counts, matches: matches, loadProducts: loadProducts, ordered: ordered, gradeSummary: gradeSummary };
  var root = document.querySelector('[data-stock-collection]');
  if (!root) return;
  var current = new URL(window.location.href);
  var isSearch = root.hasAttribute('data-stock-search');
  var selected = current.searchParams.getAll(conditionParam).flatMap(function (value) { return value.split(','); });
  var status = root.querySelector('[data-stock-status]');
  var results = root.querySelector('[data-stock-results]');
  var form = document.getElementById('FiltersForm');
  // Shopify's request object has no filter_params property. Keep actual active
  // filters through sorting, and preserve sorting when a filter is selected.
  var sort = root.querySelector('select[name="sort_by"]');
  var activeSort = current.searchParams.get('sort_by') || (sort && sort.value);
  if (sort) {
    sort.removeAttribute('onchange');
    sort.addEventListener('change', function () {
      var target = new URL(current);
      target.searchParams.set('sort_by', sort.value);
      target.searchParams.delete('page');
      window.location.assign(target);
    });
  }
  if (form && activeSort) {
    var sortInput = document.createElement('input');
    sortInput.type = 'hidden';
    sortInput.name = 'sort_by';
    sortInput.value = activeSort;
    form.appendChild(sortInput);
  }

  var stockUrl = new URL(root.dataset.stockCollection, current.origin);
  stockUrl.search = current.search;
  stockUrl.searchParams.delete(conditionParam);
  stockUrl.searchParams.set('view', 'stock-data');
  if (activeSort) stockUrl.searchParams.set('sort_by', activeSort);
  if (isSearch) stockUrl.searchParams.set('type', 'product');
  if (root.hasAttribute('data-stock-lazy')) return;
  loadProducts(stockUrl, window.fetch.bind(window)).then(function (products) {
    var stockCounts = counts(products);
    document.querySelectorAll('[data-stock-condition]').forEach(function (label) {
      var input = label.querySelector('input');
      var count = stockCounts.get(input.value) || 0;
      label.querySelector('.facet__opt-count').textContent = count;
      input.disabled = count === 0 && !input.checked;
      label.hidden = count === 0;
      label.style.display = count === 0 ? 'none' : '';
    });
    // Sort all matching stock before pagination, using the same available grades
    // as the displayed From price. Sold-out zero-price variants do not participate.
    var filtered = ordered(matches(products, selected), activeSort);
    var pages = Math.ceil(filtered.length / pageSize);
    var page = Math.min(Math.max(parseInt(current.searchParams.get('page'), 10) || 1, 1), pages || 1);
    var offset = (page - 1) * pageSize;
    document.querySelectorAll('[data-stock-result-total]').forEach(function (node) {
      node.textContent = filtered.length + (filtered.length === 1 ? ' product' : ' products');
    });
    root.querySelector('[data-stock-result-range]').textContent = filtered.length
      ? (offset + 1) + '\u2013' + Math.min(offset + pageSize, filtered.length) + ' of ' + filtered.length
      : '0 products';
    results.replaceChildren();
    if (!filtered.length) {
      var empty = document.createElement('div');
      empty.className = 'col-empty';
      var heading = document.createElement('h3');
      heading.textContent = 'Nothing matches those filters right now.';
      var clear = document.createElement('a');
      clear.className = 'btn btn--ink';
      clear.href = root.dataset.stockClear || root.dataset.stockCollection;
      clear.textContent = 'Clear filters';
      empty.append(heading, clear);
      results.appendChild(empty);
    } else {
      var list = document.createElement('div');
      list.className = 'deals-list';
      filtered.slice(offset, offset + pageSize).forEach(function (product) {
        var template = document.createElement('template');
        template.innerHTML = product.html;
        var row = template.content.querySelector('.prow');
        if (!row) throw new Error('Stock row unavailable');
        if (product.pushed) row.classList.add('prow--push');
        var stock = row.querySelector('.prow__stock');
        if (stock) stock.textContent = product.variants.reduce(function (sum, variant) { return sum + variant.quantity; }, 0) + ' in stock';
        var grades = row.querySelector('[data-stock-grades]');
        if (grades) grades.textContent = gradeSummary(product.variants);
        var allowedIds = product.variants.map(function (variant) { return String(variant.id); });
        row.querySelectorAll('[data-row-cart]').forEach(function (option) {
          if (!allowedIds.includes(option.dataset.variant)) option.remove();
        });
        var offers = Array.from(row.querySelectorAll('[data-row-cart]'));
        var price = row.querySelector('[data-row-price]');
        if (offers.length && price) {
          var cheapest = offers.reduce(function (a, b) { return Number(a.dataset.price) <= Number(b.dataset.price) ? a : b; });
          price.textContent = (offers.length > 1 ? 'From ' : '') + cheapest.dataset.priceText;
        }
        if (selected.length) {
          row.querySelectorAll('a[href]').forEach(function (link) {
            var target = new URL(link.getAttribute('href'), current.origin);
            if (target.pathname.includes('/products/')) {
              target.searchParams.set('variant', product.variants[0].id);
              link.href = target.toString();
            }
          });
        }
        list.appendChild(template.content);
      });
      results.appendChild(list);
    }
    if (pages > 1) {
      var nav = document.createElement('nav');
      nav.className = 'mono col-pagination';
      nav.setAttribute('aria-label', 'Pagination');
      for (var index = 1; index <= pages; index++) {
        var link = document.createElement(index === page ? 'span' : 'a');
        link.textContent = index;
        if (index === page) link.setAttribute('aria-current', 'page');
        else {
          var target = new URL(current);
          target.searchParams.set('page', index);
          link.href = target.toString();
        }
        nav.appendChild(link);
      }
      results.appendChild(nav);
    }
    results.hidden = false;
    status.hidden = true;
  }).catch(function () {
    status.textContent = 'Unable to check stock by condition. Please refresh to try again.';
    // Never show a product's total stock as proof of the selected grade's stock.
    if (selected.length) results.hidden = true;
  });
}());
